// https://stackoverflow.com/questions/73194573/why-does-babel-in-create-react-app-not-polyfill-array-prototype-at-properly
import R from 'core-js/stable';

// eslint-disable-next-line no-unused-expressions
R;
